import type { LegalDoc } from '../types/content';

export const LEGAL_DRAFT_NOTICE =
  'Draft for review by qualified legal counsel. This content is provided as a starting point and is not legal advice.';

export const legalDocs: LegalDoc[] = [
  {
    slug: 'privacy',
    title: 'Privacy Policy',
    summary: 'How Corventa Talent Search collects, uses and protects personal information.',
    updated: '2026-10-01',
    sections: [
      { heading: 'Who we are', body: ['Corventa Talent Search ("Corventa", "we", "us") provides recruitment and executive search services. Registered company details: [Company registration details to be added].'] },
      { heading: 'Information we collect', body: ['We collect information you provide through our forms, such as your name, contact details, professional history and documents you upload. We may also collect limited technical information required to operate the website securely.'] },
      { heading: 'How we use information', body: ['We use personal information to respond to inquiries, provide recruitment services, communicate about relevant opportunities you have agreed to receive, and meet legal obligations.'] },
      { heading: 'Legal bases', body: ['Depending on your jurisdiction, we rely on consent, legitimate interests, performance of a contract and legal obligations as the bases for processing.'] },
      { heading: 'Sharing', body: ['We never share a candidate’s details with a prospective employer without the candidate’s permission. We may use trusted service providers who process data on our behalf under appropriate agreements.'] },
      { heading: 'Your rights', body: ['You may request access to, correction or deletion of your personal information, or object to certain processing. Contact: [Privacy contact email to be added].'] },
    ],
  },
  {
    slug: 'cookies',
    title: 'Cookie Policy',
    summary: 'How this website uses cookies and similar technologies.',
    updated: '2026-10-01',
    sections: [
      { heading: 'Current use', body: ['This website currently uses only essential browser storage to remember your cookie preferences. No analytics or marketing cookies are active.'] },
      { heading: 'Optional cookies', body: ['If analytics or marketing tools are introduced in future, they will remain disabled unless you opt in through the cookie preferences panel.'] },
      { heading: 'Managing preferences', body: ['You can change your choices at any time using the "Cookie preferences" link in the website footer, or by clearing your browser storage.'] },
    ],
  },
  {
    slug: 'terms',
    title: 'Website Terms of Use',
    summary: 'The terms that apply when you use this website.',
    updated: '2026-10-01',
    sections: [
      { heading: 'Use of this website', body: ['By using this website you agree to use it lawfully and not to interfere with its operation or security.'] },
      { heading: 'Content', body: ['Content is provided for general information. Job listings marked as samples are for demonstration and do not represent available positions.'] },
      { heading: 'Intellectual property', body: ['The Corventa name, logo and website content are the property of Corventa Talent Search unless otherwise stated.'] },
      { heading: 'Limitation of liability', body: ['To the extent permitted by law, Corventa is not liable for losses arising from reliance on website content. [Jurisdiction-specific wording to be confirmed by counsel].'] },
    ],
  },
  {
    slug: 'candidate-privacy',
    title: 'Candidate Data Privacy',
    summary: 'How we handle the personal information of candidates.',
    updated: '2026-10-01',
    sections: [
      { heading: 'Our commitment', body: ['Candidates trust us with sensitive information about their careers. We treat that trust with the highest level of discretion.'] },
      { heading: 'What we collect', body: ['Contact details, CV or résumé, career history, preferences, and notes from conversations with our consultants.'] },
      { heading: 'Consent before introduction', body: ['We will always seek your explicit permission before presenting your details to any organisation.'] },
      { heading: 'Retention', body: ['We retain candidate information only as long as necessary for recruitment purposes or as required by law. [Retention period to be confirmed].'] },
      { heading: 'Security', body: ['Candidate data will be stored with access controls, encryption in transit and limited staff access once a secure submission backend is configured.'] },
    ],
  },
  {
    slug: 'accessibility',
    title: 'Accessibility Statement',
    summary: 'Our commitment to an accessible website for everyone.',
    updated: '2026-10-01',
    sections: [
      { heading: 'Our approach', body: ['We aim to meet the Web Content Accessibility Guidelines (WCAG) 2.2 at level AA.'] },
      { heading: 'Features', body: ['Keyboard-navigable menus and accordions, visible focus states, descriptive labels, sufficient colour contrast and support for reduced-motion preferences.'] },
      { heading: 'Known limitations', body: ['Some interactive 3D visuals are decorative and are simplified or paused for users who prefer reduced motion.'] },
      { heading: 'Feedback', body: ['If you encounter a barrier, please contact us through the Contact page so we can help and improve.'] },
    ],
  },
];
